import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getDownloadUrl } from 'redux/actions/authActions';
import { showAlert } from 'redux/actions/alertActions';
import useApi from 'hooks/useApi';

import MainSpinner from 'shared/components/MainSpinner';
import { ALERT_TYPE_ERROR } from 'shared/utils';

import { AutoDownloadContactWrapper } from './styles';

const AutoDownloadContact = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const { customAreaApi } = useApi();
  const [clientNavision, setClientNavision] = useState('');
  const [clientId, setClientId] = useState('');
  const [mail, setMail] = useState('');
  const [documentId, setDocumentId] = useState('');
  const [documentName, setDocumentName] = useState('');
  const [idDownload, setIdDownload] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (search && search.length) {
      const params = new URLSearchParams(search);
      const clientNavisionParam = params.get('clientNavision');
      const clientIdParam = params.get('clientId');
      const mailParam = params.get('mail');
      const idNotifyParam = params.get('documentId');
      const documentNameParam = params.get('documentName');
      const downloadIdParam = params.get('idDownload');
      setClientNavision(clientNavisionParam);
      setClientId(clientIdParam);
      setMail(mailParam);
      setDocumentId(idNotifyParam);
      setDocumentName(documentNameParam);
      setIdDownload(downloadIdParam);
    }
  }, [search]);

  const [{ loading }, getDownload] = customAreaApi(
    {
      method: 'GET',
    },
    { manual: true }
  );

  const onDownload = async () => {
    try {
      const { data, errors } = await getDownload({
        url: `${window.REACT_APP_SERVER_URL}${
          window.API_V1
        }/cli/itemspublic/${clientNavision}/${clientId}/${encodeURIComponent(
          mail
        )}/download/${documentId}`,
      });
      if (data) {
        const url = `${window.REACT_APP_SERVER_URL}${
          window.API_V1
        }/cli/itemspublic/${clientNavision}/${clientId}/${encodeURIComponent(
          mail
        )}/download/${documentId}`;
        const result = await fetch(url, {});
        const blob = await result.blob();
        const tempLink = window.document.createElement('a');
        tempLink.href = window.URL.createObjectURL(blob);
        tempLink.setAttribute('download', documentName);
        tempLink.click();
        dispatch(getDownloadUrl(null));
        history.push('/home');
      }
      if (errors?.length) {
        throw new Error(
          errors.reduce((actual, current) => `${actual}\n${current.message}`),
          ''
        );
      }
    } catch (error) {
      console.error('getting download error: ', error);
      dispatch(
        showAlert({
          alertType: ALERT_TYPE_ERROR,
          alertMessage: t('custom_field_operation_error_message'),
        })
      );
      history.push('/home');
    }
  };

  const onDownloadZip = async () => {
    try {
      const { data } = await getDownload({
        url: `${window.REACT_APP_SERVER_URL}${
          window.API_V1
        }/cli/itemspublic/${clientNavision}/${clientId}/${encodeURIComponent(
          mail
        )}/downloadfiles/${idDownload}`,
        responseType: 'arraybuffer',
      });
      if (data) {
        setIsLoading(true);
        const blob = new Blob([data], { type: 'octet/stream' });
        const tempLink = window.document.createElement('a');
        tempLink.href = window.URL.createObjectURL(blob);
        tempLink.setAttribute('download', `${t('genera_files')}.zip`);
        tempLink.click();
        dispatch(getDownloadUrl(null));
        setIsLoading(false);
        history.push('/home');
      }
    } catch (error) {
      console.error('getting download error: ', error);
      dispatch(
        showAlert({
          alertType: ALERT_TYPE_ERROR,
          alertMessage: t('custom_field_operation_error_message'),
        })
      );
      history.push('/home');
    }
  };

  useEffect(() => {
    if (documentId !== '' && documentId !== null) {
      onDownload();
    }
    if (idDownload !== '' && idDownload !== null) {
      onDownloadZip();
    }
  }, [documentId, idDownload]);

  return (
    <AutoDownloadContactWrapper>
      {(!loading || !isLoading) && <MainSpinner />}
    </AutoDownloadContactWrapper>
  );
};

export default AutoDownloadContact;
